


















































































































































import Vue from 'vue'
import _ from 'lodash'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxScrolling, DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import {
  FETCH_ADDRESS_FELD_LIST,
  FETCH_ADDRESS_GROUP, FETCH_AGENCY_LIST, FETCH_GENERAL_SEARCH_ADDRESS_LIST,
  FETCH_LAND_LIST
} from '@/store/action-types'
import { Land } from '@/model/addresses/Land'
import AddressWindow from '@/components/master-data/address/AddressWindow.vue'
import { AddressGroup } from '@/model/addresses/AddressGroup'
import {
  AdressZusatzfelderType,
  AdressZusatzfelderTypesResponse, AgencyResponse,
  ProjectAddressSearchResponse
} from '@/types/service-response'
import { SearchAddress } from '@/model/addresses/SearchAddress'
import {
  AdressZusatzfelderSearchItem,
  ProjectGeneralAddressSearchRequestPayload
} from '@/types/payload'
import { AddressCountry } from '@/model/addresses/AddressCountry'
import { Agency } from '@/model/addresses/Agency'

import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { locale, loadMessages } from "devextreme/localization"

interface ComponentData {
  tableHeight: string,
  loading: boolean

  agencyList: Agency[]
  landList: Land[]
  addressGroupList: AddressGroup[]

  selectedAgencyId: number | null
  sortierung: string
  name: string
  vorname: string
  ort: string
  plz: string
  strasse: string
  hausnummer: string
  region: string
  land: AddressCountry | undefined
  adressgruppe: number | undefined
  telefonprivate: string
  telefonGeschaeftlich: string
  handyprivat: string
  handygeschaeftlich: string
  mailprivat: string
  mailgeschaftlich: string
  maxRecords: number

  addressList: SearchAddress[]
  isDetailButtonDisabled: boolean
  addressStatus: string
  feldList: AdressZusatzfelderType[]
  operatorList: any[]
  boolOperatorNextList: any[]
  additionalFilterList: any[]
}

export default Vue.extend({
  name: 'AddressSearchMultisitePage',

  components: {
    AddressWindow,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxStateStoring
  },

  props: {
    addressGroupId: Number
  },

  data (): ComponentData {
    return {
      tableHeight: '',
      loading: false,

      agencyList: [],
      landList: [],
      addressGroupList: [],

      selectedAgencyId: null,
      sortierung: '',
      name: '',
      vorname: '',
      ort: '',
      plz: '',
      strasse: '',
      hausnummer: '',
      region: '',
      land: undefined,
      adressgruppe: undefined,
      telefonprivate: '',
      telefonGeschaeftlich: '',
      handyprivat: '',
      handygeschaeftlich: '',
      mailprivat: '',
      mailgeschaftlich: '',
      maxRecords: 500,

      addressList: [],
      isDetailButtonDisabled: true,
      addressStatus: '1',
      feldList: [],
      operatorList: [
        {id: 1, name: '='},
        {id: 2, name: this.$t('productSearch.operator1').toString()},
        {id: 3, name: this.$t('productSearch.operator2').toString()},
        {id: 4, name: this.$t('productSearch.operator3').toString()},
        {id: 5, name: this.$t('productSearch.operator4').toString()},
        {id: 6, name: this.$t('productSearch.operator5').toString()},
        {id: 7, name: this.$t('productSearch.operator6').toString()},
        {id: 8, name: this.$t('productSearch.operator7').toString()}
      ],
      boolOperatorNextList: [
        {id: 0, name: ''},
        {id: 1, name: this.$t('productSearch.boolOperator1').toString()},
        {id: 2, name: this.$t('productSearch.boolOperator2').toString()}
      ],
      additionalFilterList: [
        {id: 1, feld: null, operator: null, inhalt: '', boolOperatorNext: null}
      ]
    }
  },

  watch: { },

  computed: {
    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },
  },

  methods: {
    onChangeFeld (index: number, item: any): void {
      if(item === 0) {
        this.additionalFilterList[index].feld = null
        this.additionalFilterList[index].operator = null
        this.additionalFilterList[index].inhalt = ''
        this.additionalFilterList[index].boolOperatorNext = 0
        this.additionalFilterList.splice(index + 1, this.additionalFilterList.length)
      }
    },

    onChangeAdditional (index: number, item: any): void {
      if(item === 0) {
        if(this.additionalFilterList && this.additionalFilterList[index + 1]) {
          this.additionalFilterList.splice(index + 1, 1)
        }
      } else {
        if(this.additionalFilterList && !this.additionalFilterList[index + 1]) {
          const highId = _.maxBy(this.additionalFilterList, 'id')
          this.additionalFilterList.push({id: highId.id + 1, feld: null, operator: null, inhalt: '', boolOperatorNext: 0})
        }
      }
    },

    onSearchButtonClick (): void {
      this.addressList = []

      let data: any = this.getRouteData()

      data.agencyId = this.selectedAgencyId
      data.sortierung = this.sortierung
      data.name = this.name
      data.vorname = this.vorname
      data.ort = this.ort
      data.plz = this.plz
      data.strasse = this.strasse
      data.hausnummer = this.hausnummer
      data.region = this.region
      data.land = this.land
      data.adressgruppe = this.adressgruppe
      data.telefonprivate = this.telefonprivate
      data.telefonGeschaeftlich = this.telefonGeschaeftlich
      data.handyprivat = this.handyprivat
      data.handygeschaeftlich = this.handygeschaeftlich
      data.mailprivat = this.mailprivat
      data.mailgeschaftlich = this.mailgeschaftlich
      data.addressStatus = this.addressStatus
      data.adressZusatzfelderSearchItems = this.additionalFilterList

      this.$router.push({name: 'AddressSearchMultisite', query: { data: JSON.stringify(data) }})

      this.searchAddress()
    },

    onResize (): void {
      if(this.$refs.filter && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.filter as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 105px - ${height}px)`
        } else {
          this.tableHeight = '300px'
        }
      } else {
        this.tableHeight = '300px'
      }
    },

    async searchAddress (): Promise<void> {
      let additionalFilterSearchList: AdressZusatzfelderSearchItem[] = []
      this.additionalFilterList.forEach((item: any) => {
        if(item.feld && item.operator && item.inhalt) {
          additionalFilterSearchList.push({
            Feldtyp: item.feld,
            Operator: item.operator,
            BoolOperatorNext: item.boolOperatorNext,
            Inhalt: item.inhalt
          })
        }
      })
      const payload: ProjectGeneralAddressSearchRequestPayload = {
        Agency: this.selectedAgencyId,
        Sortierung: this.sortierung,
        Adressgruppe: this.adressgruppe ? this.adressgruppe.toString() : '',
        Name: this.name,
        Region: this.region,
        Vorname: this.vorname,
        Land: this.land ? this.land.name : '',
        Ort: this.ort,
        Telefonprivat: this.telefonprivate,
        Telefongeschaeftlich: this.telefonGeschaeftlich,
        Handyprivat: this.handyprivat,
        Handygeschaeftlich: this.handygeschaeftlich,
        AdressZusatzfelderSearchItems: additionalFilterSearchList,
        PLZ: this.plz,
        Mailprivat: this.mailprivat,
        Strasse: this.strasse,
        Hausnummer: this.hausnummer,
        Mailgeschaeftlich: this.mailgeschaftlich,
        Sprache: this.selectedLanguageId,
        Mitarbeiter: this.currentUserId,
        MaxRecords: this.maxRecords,
        Aktiv: this.addressStatus === '1',
        Passiv: this.addressStatus === '2',
        Alle: this.addressStatus === '0',
      }

      try {
        this.loading = true
        const response: ProjectAddressSearchResponse = await this.$store.dispatch(FETCH_GENERAL_SEARCH_ADDRESS_LIST, payload)
        if(!response.IsError) {
          this.addressList = SearchAddress.createFromResponse(response.Results)
        }
        this.loading = false
      } catch {
        this.loading = false
      }
    },

    async fetchFeldList (): Promise<void> {
      try {
        const response: AdressZusatzfelderTypesResponse = await this.$store.dispatch(FETCH_ADDRESS_FELD_LIST)
        if(!response.IsError) {
          this.feldList = response.Data
          this.feldList.unshift({
            ID: 0,
            Bezeichnung: ''
          })
        }
      } catch {
      }
    },

    async fetchAgencyList (): Promise<void> {
      try {
        const response: AgencyResponse = await this.$store.dispatch(FETCH_AGENCY_LIST)
        if (response && !response.IsError && response.Data) {
          this.agencyList = Agency.createFromResponse(response.Data)
          if(this.agencyList[0]) {
            this.selectedAgencyId = this.agencyList[0].id
          }
        }
      } catch {

      }
    },

    getRouteData (): Object {
      let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      return data
    },

    setDataFromRoute () {
      let data: any = this.getRouteData()

      if(this.$route.path === '/address-search-multisite') {
        this.selectedAgencyId = data.agencyId ? data.agencyId : this.agencyList[0] ? this.agencyList[0].id : null
        this.sortierung = data && data.sortierung ? data.sortierung : ''
        this.name = data && data.name ? data.name : ''
        this.vorname = data && data.vorname ? data.vorname : ''
        this.ort = data && data.ort ? data.ort : ''
        this.plz = data && data.plz ? data.plz : ''
        this.strasse = data && data.strasse ? data.strasse : ''
        this.hausnummer = data && data.hausnummer ? data.hausnummer : ''
        this.region = data && data.region ? data.region : ''
        this.land = data && data.land ? data.land : undefined
        this.adressgruppe = data && data.adressgruppe ? data.adressgruppe : undefined
        this.telefonprivate = data && data.telefonprivate ? data.telefonprivate : ''
        this.telefonGeschaeftlich = data && data.telefonGeschaeftlich ? data.telefonGeschaeftlich : ''
        this.handyprivat = data && data.handyprivat ? data.handyprivat : ''
        this.handygeschaeftlich = data && data.handygeschaeftlich ? data.handygeschaeftlich : ''
        this.mailprivat = data && data.mailprivat ? data.mailprivat : ''
        this.mailgeschaftlich = data && data.mailgeschaftlich ? data.mailgeschaftlich : ''
        this.addressStatus = data && data.addressStatus ? data.addressStatus : '1'
        this.additionalFilterList = data && data.adressZusatzfelderSearchItems ? data.adressZusatzfelderSearchItems : [{id: 1, feld: null, operator: null, inhalt: '', boolOperatorNext: null}]

        if(!_.isEmpty(data)) {
          this.searchAddress()
        }
      }
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  async mounted (): Promise<void> {
    this.setDataFromRoute()
    this.fetchAgencyList()
    this.landList = await this.$store.dispatch(FETCH_LAND_LIST)
    this.addressGroupList = await this.$store.dispatch(FETCH_ADDRESS_GROUP)
    this.fetchFeldList()

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }
})
